import axios from 'axios';

export const paidApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/paid-signup`, withCredentials: true, timeout: 30000 });
const TOKEN_KEY = 'voxinity_paid_signup';
const PLAN_KEY = 'voxinity_paid_signup_plan';
export const readSignupToken = () => sessionStorage.getItem(TOKEN_KEY) || '';
export const saveSignupToken = token => token ? sessionStorage.setItem(TOKEN_KEY, token) : sessionStorage.removeItem(TOKEN_KEY);
export const validPlan = value => ['launchpad', 'starter', 'agency', 'pro'].includes(value?.trim().toLowerCase()) ? value.trim().toLowerCase() : null;
export const readPlan = () => validPlan(sessionStorage.getItem(PLAN_KEY));
export const savePlan = plan => plan ? sessionStorage.setItem(PLAN_KEY, plan) : sessionStorage.removeItem(PLAN_KEY);
export const paidError = err => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(e => e.msg).filter(Boolean).join(' ');
  return 'We couldn’t complete that step. Please try again.';
};
export const startPaidGoogle = async () => {
  const { data } = await paidApi.post('/google/start');
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirect = `${window.location.origin}/signup/google?state=${encodeURIComponent(data.state)}`;
  window.location.assign(`https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`);
};